import React from "react";
import Grid from "../Grid/grid";
import Title from "../title";
import Process from "../process";
import csdProcessData from "./data/csd-process-data";
import csdContent from "../../Assets/image/services-pages-images/Custom software development/csd-content.webp";

function CsdProcess() {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
      <Grid size={100} direction="top-left" />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title="our process" />
      </div>
      <Process
        data={csdProcessData}
        img={csdContent}
        title="Custom Software Development"
        description="Crafting Powerful & Scalable Software Solutions to Drive Your Business Forward."
      />
    </section>
  );
}

export default CsdProcess;
